import React from 'react'
import { makeAutoObservable } from 'mobx'

class Context {
	constructor() { makeAutoObservable(this) }

	agendas = []
	sectors = []
	cashBooks = []
	drawerOpened = false
}

export const context = new Context()

export const useContext = () => React.useContext(React.createContext(context))